import { Loader2 } from "lucide-react";

export const Splash = ({ label = "Loading" }) => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-ink gap-7" data-testid="app-splash">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(6,182,212,0.12),transparent_60%)]" />
    <img
      src="/thortek-logo.png"
      alt="Thortek Performance"
      className="relative h-12 sm:h-14 w-auto animate-pulse"
      style={{ animationDuration: "1.6s" }}
    />
    <div className="relative flex items-center gap-2 text-cyan">
      <Loader2 className="animate-spin" size={16} />
      <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-slate-500">{label}</span>
    </div>
  </div>
);
